module.exports = "<list-view\n  filter-event=\"$ctrl.filterEvent\"\n  transformer=\"RoutesTransforms\"\n  add-item-event=\"$ctrl.addItemEvent\"\n  title=\"Routes\"\n  resource=\"Route\"\n  item-state=\"route\"\n  no-items-text=\"No Routes Yet!\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/routes/routes.html
// module id = 1371
// module chunks = 0